import { initializeApp } from 'firebase/app';
import { getMessaging, getToken as getFcmToken, onMessage } from 'firebase/messaging';

// Same values must also be pasted into public/firebase-messaging-sw.js —
// service workers can't import this module directly.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

/**
 * Requests notification permission and returns an FCM token, or null if the
 * browser/OS doesn't support it or the person declines. Safari on iPhone
 * only supports this for a site added to the home screen (iOS 16.4+) — see
 * README for the caveat.
 */
export async function requestPushToken() {
  try {
    if (!('Notification' in window)) return null;
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    const messaging = getMessaging(app);
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    return await getFcmToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration: registration,
    });
  } catch (err) {
    console.warn('Push setup failed', err);
    return null;
  }
}

export function listenForForegroundMessages(onMessageReceived) {
  try {
    const messaging = getMessaging(app);
    onMessage(messaging, onMessageReceived);
  } catch (err) {
    console.warn('Foreground message listener failed', err);
  }
}
